import { DECOR } from '../../appConfig'

const LOGO = DECOR.logo.img;
const LOGO_ALT = DECOR.logo.alt

export {
  LOGO,
  LOGO_ALT
};
